<template>
  <div class="information-list-wrapper">
    <ul class="drop-list">
      <li
        v-for="(item, i) in InformationList"
        :key="i"
        class="drop-list__item"
      >
      <router-link
        class="drop-list__link"
        :to="item.slug"
      >
      {{ item.name }}
    </router-link>
    </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'InformationListDrop',
  components: {
  },
  props: {
    InformationList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>
.information-list-wrapper {
  position: absolute;
  top: 40px;
  left: 240px;
  z-index: 10;
  width: 410px;
  padding: 48px 24px;
  margin-bottom: 10px;
  background: #FFFFFF;
  border-left: 30px solid #1BA6DA;
  box-shadow: inset 0 -7px 20px -10px rgba(0, 0, 0, 0.5);

  .drop-list {
    text-align: left;

    &__item {
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__link {
      text-decoration: none;
      line-height: 19px;
      color: #1BA6DA;
      transition: 0.5s;

      @media (any-hover: hover) {
        &:hover {
          color: #0977AA;
          transition: 0.5s;
        }
      }
    }
  }
}
</style>
